import 'external-svg-loader';
import { useState, useEffect } from 'react';

export type IconAssetType = {
  url: string;
  fill?: string;
  className?: string;
  width?: number | null;
  height?: number | null;
  viewBox?: string;
};

const IconAsset = ({
  url,
  fill = 'currentColor',
  className,
  width,
  height,
  ...rest
}: IconAssetType) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && !isClient) {
      setIsClient(true);
    }
  }, [isClient]);

  const shouldRender = Boolean(url?.length) && isClient;

  return shouldRender ? (
    <svg
      data-src={url}
      fill={fill}
      className={className}
      width={width || undefined}
      height={height || undefined}
      {...rest}
    />
  ) : null;
};

export default IconAsset;
